import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { definePreset } from '@primeuix/themes';
import { authInterceptor } from '@/app/core/interceptors/auth.interceptor';
import { AuthService } from '@/app/core/services/auth.service';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        }
    }
});

import { loaderInterceptor } from '@/app/core/interceptors/loader.interceptor';
import { TranslateTitleStrategy } from '@/app/core/routing/translate-title.strategy';

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: TitleStrategy, useClass: TranslateTitleStrategy },
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([authInterceptor, loaderInterceptor])),
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            useValue: {
                prefix: '/assets/i18n/',
                suffix: '.json',
                enforceLoading: false,
                useHttpBackend: false
            }
        },
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: TranslateHttpLoader
                },
                defaultLanguage: 'pt-BR'
            })
        ),
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [AuthService, TranslateService],
            useFactory: (authService: AuthService, translate: TranslateService) => async () => {
                translate.addLangs(['pt-BR', 'en-US']);
                translate.setDefaultLang('pt-BR');
                await authService.init();

                if (!translate.currentLang) {
                    await firstValueFrom(translate.use('pt-BR'));
                }
                return;
            }
        },
        provideZonelessChangeDetection(),
        providePrimeNG({ theme: { preset: MyPreset, options: { darkModeSelector: '.app-dark' } } }),
        MessageService
    ]
};
